import { render, staticRenderFns } from "./pre_btn_control.vue?vue&type=template&id=91122a2a&scoped=true"
import script from "./pre_btn_control.vue?vue&type=script&lang=js"
export * from "./pre_btn_control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91122a2a",
  null
  
)

export default component.exports